import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/offer';
export function PainPoints() {
  return <section className="w-full bg-sand" data-id="element-116" data-mp="2lm0udb1od8u1">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-117" data-mp="2lp54ep1tmysm">
        <h2 className="font-display text-2xl font-extrabold tracking-tight text-navy-950 sm:text-3xl" data-id="element-118" data-mp="26xwhinpazrj6">
          Es frustrante entrar a la cancha y…
        </h2>
        <ul className="mt-8 divide-y divide-navy-200/60 border-y border-navy-200/60" data-id="element-119" data-mp="1xxhwzqk5yggq">
          {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-5" data-id="element-120" data-mp="220we6kju92vr">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-navy-950" data-id="element-121" data-mp="1o0d83iyxo6w8">
                <XIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-122" data-mp="1szpxaada1q1z" />
              </span>
              <p className="text-base leading-relaxed text-navy-800 sm:text-lg" data-id="element-123" data-mp="3iemgpmvb7j3a">{point}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}